import CategoriesItemKitchen from "./CategoriesItemKitchen";
import Footer from "../Footer";
import Newsletter from "../Newsletter";

function Kitchen() {
  return (
    <>
      <CategoriesItemKitchen />
      <Newsletter />
      <Footer />
    </>
  );
}

export default Kitchen;
